export default __webpack_public_path__ + "static/media/settings.47dbfbf5.svg";